import logger from "../logger/logger-init"
import { depictClientConfig } from "./interfaces/IDepictClientConfig"
import { DepictClient } from "@/lib/depict-client/DepictClient"
import { SearchApiService } from "@/lib/depict-client/services/SearchApiService"
import { ListingApiService } from "@/lib/depict-client/services/ListingApiService"
import { RecommendationsApiService } from "@/lib/depict-client/services/RecommendationsApiService"
import { OtherApiService } from "@/lib/depict-client/services/OtherApiService"
import { ClientFetchService } from "@/lib/http/ClientFetchService"

const clientFetchService = new ClientFetchService(depictClientConfig, logger)

const searchApiService = new SearchApiService(clientFetchService)

const listingApiService = new ListingApiService(clientFetchService)

const recommendationsApiService = new RecommendationsApiService(clientFetchService)

const otherApiService = new OtherApiService(clientFetchService)

const depictClientOnlyClient = new DepictClient(
    searchApiService,
    listingApiService,
    recommendationsApiService,
    otherApiService
)

export default depictClientOnlyClient
